import { Controller } from '@hotwired/stimulus'

const SECOND = 1000
const MINUTE = 60 * SECOND
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR
const REFRESH_INTERVAL = 30 * SECOND

export default class extends Controller {
  static values = {
    deadline: String,
    start: String,
    format: String,
    secondsFormat: String,
    day2Rate: String,
    day2Label: String,
    day1Tone: String,
    day2Tone: String,
  }

  static targets = ['counter', 'rate', 'label']

  initialize() {
    this.timer = null
  }

  connect() {
    this.#refresh()
  }

  disconnect() {
    this.#stop()
  }

  #refresh() {
    const countdown = this.hasDeadlineValue
    const distance = countdown
      ? new Date(this.deadlineValue) - Date.now()
      : Date.now() - new Date(this.startValue)

    if (countdown && distance <= 0) {
      this.#stop()
      this.counterTarget.remove()
      this.rateTarget.textContent = this.day2RateValue
      this.labelTarget.textContent = this.day2LabelValue
      this.#applyDay2Tone()

      return
    }

    this.counterTarget.textContent = this.#formatted(distance)
    this.timer = setTimeout(() => this.#refresh(), this.#nextDelay(distance))
  }

  #applyDay2Tone() {
    if (!this.hasDay1ToneValue || !this.hasDay2ToneValue) return

    this.element.classList.remove(...this.day1ToneValue.split(' '))
    this.element.classList.add(...this.day2ToneValue.split(' '))
  }

  #formatted(distance) {
    if (this.#final(distance)) {
      return this.secondsFormatValue.replace('%{seconds}', Math.ceil(distance / SECOND))
    }

    return this.formatValue
      .replace('%{days}', Math.floor(distance / DAY))
      .replace('%{hours}', Math.floor((distance % DAY) / HOUR))
      .replace('%{minutes}', Math.floor((distance % HOUR) / MINUTE))
  }

  #nextDelay(distance) {
    return this.#final(distance) ? SECOND : REFRESH_INTERVAL
  }

  #final(distance) {
    return this.hasDeadlineValue && this.hasSecondsFormatValue && distance < MINUTE
  }

  #stop() {
    clearTimeout(this.timer)
    this.timer = null
  }
}
